import { NotAuthorized } from "@/components/NotAuthorized";
import { LoadingState } from "@/components/podkit/loading/LoadingState";
import { useDocumentTitle } from "@/hooks/use-document-title";
import { useMembership } from "@/hooks/use-membership";
import { LoginAndSecurity } from "@/routes/settings/login/LoginAndSecurity";
import { OrganizationRole, OrganizationTier } from "gitpod-next-api/gitpod/v1/organization_pb";
import type { FC } from "react";
import { useOrganization } from "@/queries/organization-queries";

export const LoginAndSecurityPage: FC = () => {
    useDocumentTitle("Login and security");

    const { membership, isPending: isLoadingMembership } = useMembership();
    const { data: organization, isPending: isLoadingOrganization } = useOrganization();

    if (isLoadingMembership || !membership || isLoadingOrganization || !organization) {
        return <LoadingState />;
    }

    if (membership.userRole !== OrganizationRole.ADMIN) {
        return <NotAuthorized />;
    }

    const isEnterpriseTier = organization.tier === OrganizationTier.ENTERPRISE;

    return (
        <div className="flex max-w-[550px] flex-col" data-testid="login-and-security-page">
            <LoginAndSecurity organizationId={membership.organizationId} isEnterpriseTier={isEnterpriseTier} />
        </div>
    );
};
